// @mui
import { Skeleton, Card, CardContent, Typography, Stack } from '@mui/material';

// -------------------

export default function SkeletonTodoCard() {
  return (
    <Card
      variant="outlined"
      sx={{
        padding: (theme) => theme.spacing(1),
        height: 260,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        position: 'relative',
      }}
    >
      <CardContent>
        <Stack spacing={1} sx={{ mb: 2, display: 'block' }}>
          <Typography variant="subtitle1"><Skeleton /></Typography>
          <Typography variant="subtitle2"><Skeleton /></Typography>
          <Skeleton height={40} />
        </Stack>
        <Skeleton height={30} />
      </CardContent>
    </Card>
  );
};
